
export { ApproveModalContent } from "/vercel/path0/packages/widgets-internal/swap/ApproveModalContent.tsx"